import IndividualCoffeeComponents from './indibidualCoffeeComponents';
import useMedia from 'use-media';
import React, { useState } from 'react';

function CoffeComponent() {
    const isLargeScreen = useMedia('(min-width: 601px)');
    const isSmallScreen = useMedia('(max-width: 600px)');
    const [roastType, setRoastType] = useState("light");
    const [arrowSrcLeft] = useState("./img/leftArrow.png");
    const [arrowSrcRight] = useState("./img/rigthArrow.png");
    const hasWindow = typeof window !== 'undefined';

    let screenSize = {
        width: hasWindow && window.screen.width,
        height: hasWindow && window.screen.height
    }
    let [roastArrayPos, setRoastArrayPos] = useState(0);

    const roastTypeWeHave = [
        {
            roast: "light"
        },
        {
            roast: "medium"
        },
        {
            roast: "dark"
        },
    ]

    const imgRotation = (event) => {
        let roastPositionInAry = roastArrayPos;
        if (event && event.target && event.target.attributes && event.target.attributes["orientation"].value === "left") {
            if ((roastPositionInAry -1) >= 0) {
                roastPositionInAry = roastPositionInAry - 1;
            }
        } else if (event && event.target && event.target.attributes && event.target.attributes["orientation"].value === "right") {
            if ((roastPositionInAry +1) < 3 ) {
                roastPositionInAry = roastPositionInAry + 1;
            }
        }
        setRoastArrayPos(roastPositionInAry);
        setRoastType(roastTypeWeHave[roastPositionInAry].roast);
    }

    return (
        <div>
            {isSmallScreen &&
                <div id="coffeImg" style={{ height: "100vh", maxHeight: "350px", width: "100%", display: "flex", flexFlow: "column", placeItems: "center" }}>
                    
                    {roastType && 
                        <IndividualCoffeeComponents isLargeScreen={isLargeScreen} isSmallScreen={isSmallScreen} roast={roastType} screenSize={screenSize} componentCount={crypto.randomUUID()}/>
                    }
                    
                    <div style={{ display: "flex", justifyContent: "flex-end", width: "100%", paddingRight: "30px" }}>
                        <div style={{ marginRight: "5px" }}>
                            <img src={arrowSrcLeft} width="20px" height="20px" orientation="left" onClick={imgRotation} alt=''/>
                        </div>
                        <div >
                            <img src={arrowSrcRight} width="20px" height="20px" orientation="right" onClick={imgRotation} alt=''/>
                        </div>
                    </div>
                </div>
            }
             {isLargeScreen &&
                <div id="coffeImg" style={{ display: "flex",  width: "100%", justifyContent: "space-around", paddingTop: "20px", paddingBottom: "20px",  }}>
                    <IndividualCoffeeComponents isLargeScreen={isLargeScreen} isSmallScreen={isSmallScreen} roast="light"  screenSize={screenSize} componentCount={crypto.randomUUID()}/>
                    <IndividualCoffeeComponents isLargeScreen={isLargeScreen} isSmallScreen={isSmallScreen} roast="medium" screenSize={screenSize} componentCount={crypto.randomUUID()}/>
                    <IndividualCoffeeComponents isLargeScreen={isLargeScreen} isSmallScreen={isSmallScreen} roast="dark"   screenSize={screenSize} componentCount={crypto.randomUUID()}/>
                </div>
            }
        </div>
        
    )
}
export default CoffeComponent;